export default __webpack_public_path__ + "static/media/c.bf0af88d.png";